import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Logo,
  NameText,
  NavbarContainer,
  PlanText,
  ProfileCard,
  ProfileSection,
  TopSection,
  UserInfo,
} from "./styles";

import avantiicon from "../../../assets/avantiicon.png";
import bars from "../../../assets/bars.png";
import close from "../../../assets/close.png";
import cardavanti from "../../../assets/cardavanti.png";

const Navbar = ({
  userData,
  drawerIsOpen,
  setDrawerIsOpen,
  tabsNames,
  handleOnChangeTab,
  currIndex,
  rightComponent,
}) => {
  const { LoyaltyCategory__c, FirstName, LastName } = userData;

  return (
    <NavbarContainer>
      <TopSection>
        <Logo src={avantiicon} alt="Logo" />
        {/* <ProfileSection>
            <ProfileCard src={cardavanti} alt="Profile" />
            <UserInfo>
              <PlanText>{LoyaltyCategory__c}</PlanText>
              <NameText>{`${FirstName} ${LastName}`}</NameText>
            </UserInfo>
          </ProfileSection> */}
        <div>
          <img
            onClick={() => setDrawerIsOpen(!drawerIsOpen)}
            src={drawerIsOpen ? close : bars}
            alt="menu"
            className="bars-icon"
          />
        </div>
      </TopSection>
      {drawerIsOpen && (
        <>
          {tabsNames.map((title, index) => (
            <a
              key={index}
              type="button"
              className={`tabs-item ${
                index === currIndex ? "active" : "disabled"
              }`}
              disabled={index === currIndex}
              onClick={(rest) => handleOnChangeTab(index, rest)}
            >
              <span className={index === currIndex ? "active" : "disabled"}>
                {title}
              </span>
              {index === currIndex ? (
                <span className="selected-tab" />
              ) : (
                <span />
              )}
            </a>
          ))}
          {rightComponent && rightComponent()}
        </>
      )}
    </NavbarContainer>
  );
};

export default Navbar;
